import { createSelector } from 'reselect'

const getCurrentLibrarySettings = state => state.libraries.current.settings

const private_library_get_current_library_type_selector = createSelector(
	[ getCurrentLibrarySettings ],
	currentLibrarySettings => currentLibrarySettings.entity_type
)

export default private_library_get_current_library_type_selector
